import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'

interface TaskAction extends Action {
    payload: any
}

const { onRequest, onSuccess, onFailure } = rootActions.notification.staticEnums

function* staticEnumsSagaTask() {
    try {
        const response = yield axios.get('/notifications/static-enums')
        if (response.success) {
            yield put(onSuccess(response.result))
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* staticEnumsSaga(): any {
    yield takeLatest<TaskAction>(onRequest, staticEnumsSagaTask)
}

export default staticEnumsSaga
